import clsx from 'clsx';

interface DividerProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}
export const Divider = ({
  className,
  orientation = 'horizontal',
}: DividerProps) => {
  return (
    <hr
      className={clsx(
        ' border-t-0 bg-neutral-100 dark:bg-white/10',
        orientation === 'horizontal' ? 'w-full h-0.5' : 'h-full w-0.5',
        className,
      )}
    />
  );
};
